<template>
  <div class="footer" >
    <div class="container clearfix" style='text-align: center;' >
       <div class="bottom-desc" >
        <p>职人联盟，找人雇猎头，就上OKLIE</p>
      </div>
      <!-- <img class="logo" src="../assets/img/logo_gray.png" /> -->
      <!-- <div class="bottom-desc" >
        <p>关于我们</p>
        <p><a href="https://github.com/chenjinya" target="__blank" >Github</a></p>
        <p><a>合作: bd@oklie.cn</a></p>
      </div> -->
     
    </div>
    <div class="container" >
      <p class="copy-right" >©2020 oklie.cn. All Rights Reserved</p>
    </div>
   
  </div>
</template>


<script>
export default {
  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },
  mounted() { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="postcss" >
.copy-right {
  text-align: center;
  color: #eee;
  font-size: 12px;
  padding: 4px;
}
.footer {
  background: linear-gradient(90deg, #031429, #03234a);
  margin: 0 auto;
  padding: 10px 0;
  position: relative;

}

.logo {
  height: 40px;
  display: block;
  margin: 20px auto;
}
.bottom-desc {
  display: inline-block;
  letter-spacing: 10px;
  margin: 20px;
  font-size: 20px;
  color: #fff;
  & p {
    margin: 10px 0 10px 0;
  }
  & a {
    color: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?1306048a